class EuregioRecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.loadProducts();
  }

  async loadProducts() {
    let viewedProducts = [];

    try {
      viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    } catch (_error) {
      viewedProducts = [];
    }

    const currentProductId = String(this.dataset.currentProductId || '');
    const productIds = viewedProducts
      .map(String)
      .filter((id) => id && id !== currentProductId)
      .slice(0, 4);

    if (productIds.length === 0) {
      this.hidden = true;
      return;
    }

    const url = new URL(this.dataset.searchUrl, window.location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', 'predictive-search');

    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const results = documentFragment.querySelector('#predictive-search-products ul');

      if (!results || !results.children.length) {
        this.hidden = true;
        return;
      }

      const destination = this.querySelector('[data-ets-recently-viewed-results]');
      if (!destination) return;

      const cards = Array.from(results.children).slice(0, 4).map((card) => {
        const clone = card.cloneNode(true);
        clone.className = 'ets-recently-viewed__card';

        const title = clone.querySelector('.resource-card__title')?.textContent || '';
        const strengthMatch = title.match(/(?:^|\s)(0|3|4[,.]5|5|6|9|10|11|12|18|20)\s*mg(?:\s*\/\s*ml)?(?:\s|$)/i);
        const media = clone.querySelector('.resource-card__media');

        if (strengthMatch && media) {
          const badge = document.createElement('span');
          badge.className = 'ets-recently-viewed__badge';
          badge.textContent = `${strengthMatch[1].replace(',', '.')} mg`;
          media.prepend(badge);
        }

        return clone;
      });

      destination.replaceChildren(...cards);
      this.hidden = false;
    } catch (_error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('euregio-recently-viewed')) {
  customElements.define('euregio-recently-viewed', EuregioRecentlyViewed);
}
